import { combineReducers } from 'redux';

import spinner from './Spinner';

export default combineReducers({
  spinner,
});
